import { render, staticRenderFns } from "./PrkInfoTypeBox.vue?vue&type=template&id=7b99134a&scoped=true&"
import script from "./PrkInfoTypeBox.vue?vue&type=script&lang=js&"
export * from "./PrkInfoTypeBox.vue?vue&type=script&lang=js&"
import style0 from "./PrkInfoTypeBox.vue?vue&type=style&index=0&id=7b99134a&scoped=true&lang=scss&"
import style1 from "./PrkInfoTypeBox.vue?vue&type=style&index=1&id=7b99134a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b99134a",
  null
  
)

export default component.exports